import { render } from "./04_Actualites.vue?vue&type=template&id=34e47b6e&scoped=true"
import script from "./04_Actualites.vue?vue&type=script&lang=js"
export * from "./04_Actualites.vue?vue&type=script&lang=js"

import "./04_Actualites.vue?vue&type=style&index=0&id=34e47b6e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e47b6e"]])

export default __exports__